import { Injectable, inject, signal, computed } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { SectionConfigDto } from '@anessa/shared-models';
import { SectionConfigApiService } from './section-config-api.service';

@Injectable({ providedIn: 'root' })
export class SectionConfigsStore {
  private readonly api = inject(SectionConfigApiService);

  private readonly sectionsSignal = signal<SectionConfigDto[]>([]);
  readonly sections = this.sectionsSignal.asReadonly();

  readonly uniqueGroups = computed(() =>
    [...new Set(this.sections().map((s) => s.group).filter((g): g is string => !!g))],
  );

  load(plantId?: string): Observable<SectionConfigDto[]> {
    return this.api.getAll(plantId).pipe(tap((sections) => this.sectionsSignal.set(sections)));
  }

  addSection(dto: SectionConfigDto): void {
    this.sectionsSignal.update((sections) => [...sections, dto]);
  }

  updateSection(dto: SectionConfigDto): void {
    this.sectionsSignal.update((sections) =>
      sections.map((s) => (s.id === dto.id ? dto : s)),
    );
  }

  removeSection(id: string): void {
    this.sectionsSignal.update((sections) => sections.filter((s) => s.id !== id));
  }
}
